import React from "react"
import ImageTween from "./imageTween"

const AboutInstaGrid = () => {
  return (
    <div className="row">
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-1.jpg")}
          srcSet={require("../assets/images/about-insta-1@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-2.jpg")}
          srcSet={require("../assets/images/about-insta-2@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-3.jpg")}
          srcSet={require("../assets/images/about-insta-3@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-4.jpg")}
          srcSet={require("../assets/images/about-insta-4@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-5.jpg")}
          srcSet={require("../assets/images/about-insta-5@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-6.jpg")}
          srcSet={require("../assets/images/about-insta-6@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-7.jpg")}
          srcSet={require("../assets/images/about-insta-7@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-8.jpg")}
          srcSet={require("../assets/images/about-insta-8@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-9.jpg")}
          srcSet={require("../assets/images/about-insta-9@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-10.jpg")}
          srcSet={require("../assets/images/about-insta-10@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-11.jpg")}
          srcSet={require("../assets/images/about-insta-11@2x.jpg")}
          alt=""
        />
      </div>
      <div className="col-md-3 col-6">
        <ImageTween
          src={require("../assets/images/about-insta-12.jpg")}
          srcSet={require("../assets/images/about-insta-12@2x.jpg")}
          alt=""
        />
      </div>
    </div>
  )
}

export default AboutInstaGrid
